import ApplicationsSearch from '../../../../../../../components/AppUtils/ApplicationsSearch';
import { GetApplicationsInfoIndex } from '../../../../../../ApplicationInformation/ApplicationInformation_api';
import { useState, useEffect } from 'react';
import Spinner from '../../../../../../../components/UI/Spinner/Spinner';
const CMSApplicationSearch = ({ name, disabled, onChange, field }) => {
	const [isLoading, setIsLoading] = useState(false);
	const [appOptions, setAppOptions] = useState([]);

	useEffect(() => {
		setIsLoading(true);

		GetApplicationsInfoIndex()
			.then(response => {
				let apps = response;

				setAppOptions(apps?.applications);
			})
			.then(x => setIsLoading(false));
	}, []);

	const handleAppChange = e => {
		const appID = e.target.value;

		if (!disabled) {
			//mock event object
			let event = {
				target: {
					name: name,
					value: appID.toString(),
				},
			};
			//call onChange prop and pass mock event to update object
			onChange(event);
		}
	};

	return (
		<>
			{isLoading ? (
				<Spinner />
			) : (
				<ApplicationsSearch
					options={appOptions}
					onChange={handleAppChange}
					disabled={disabled}
				/>
			)}
		</>
	);
};

export default CMSApplicationSearch;
